module.exports = "/packs/media/images/Sabbatical-578cf696e67b6e968e02c3afbd254c96.png";